<template>
    <div class="page-wrapper">
        <h3 class="tit">总部园区</h3>
        <div class="top-btns">
            <el-button class="r-btn" type="primary" icon="el-icon-edit" size="medium" @click="editHandle" :disabled="!uneditable">编辑表单</el-button>
            <br>
            <el-button class="r-btn" type="success" icon="el-icon-link" size="medium" @click="linkToDataV">查看大屏</el-button>
            <br>
            <el-button class="r-btn" type="warning" icon="el-icon-circle-check" size="medium" @click="takeEffectAtOnce">立即生效</el-button>
            <br>
            <el-button class="r-btn" type="info" icon="el-icon-top" size="medium" @click="toPageTop">回到顶部</el-button>
        </div>
        
        <div class="datav-form-wrapper">
            <el-form class="c-form" :model="editForm" ref="editForm" label-position="top">
                <el-form-item class="c-form-item" label="当月实时订单总额">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/001.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/001.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        当月实时订单总额 = 最小金额和最大金额之间的数值，该数值有规律递增
                    </p>
                    <el-form-item class="c-form-item-inner" label="金额范围（万元，正整数）" required>   
                        <el-col :span="6">
                            <el-form-item
                                prop="monthOrderAmount.min"
                                :rules="[
                                    { required: true, message: '请输入整数最小金额', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthOrderAmount.min = switchToInt(editForm.monthOrderAmount.min, 'unsigned');switchObjMaxAndMin(editForm.monthOrderAmount)"
                                    v-model="editForm.monthOrderAmount.min"
                                    placeholder="请输入最小金额"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthOrderAmount.max"
                                :rules="[
                                    { required: true, message: '请输入整数最大金额', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthOrderAmount.max = switchToInt(editForm.monthOrderAmount.max, 'unsigned');switchObjMaxAndMin(editForm.monthOrderAmount)"
                                    v-model="editForm.monthOrderAmount.max"
                                    placeholder="请输入最大金额"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="当月小加工单订单金额">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/002.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/002.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        当月小加工单订单金额 = 当月实时订单总额 * 当月小加工单订单比例<br>
                        当月小加工单订单比例 = 最小比例和最大比例之间的随机值
                    </p>
                    <el-form-item class="c-form-item-inner" label="当月小加工单订单比例范围（小数，例如0.83，代表83%）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthSmallOrder.rateMin"
                                :rules="[
                                    { required: true, message: '请输入最小比例', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthSmallOrder.rateMin = switchToFloat(editForm.monthSmallOrder.rateMin, 'unsigned');switchObjMaxAndMin(editForm.monthSmallOrder,'rateMin','rateMax')"
                                    v-model="editForm.monthSmallOrder.rateMin"
                                    placeholder="请输入最小比例"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthSmallOrder.rateMax"
                                :rules="[
                                    { required: true, message: '请输入最大比例', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthSmallOrder.rateMax = switchToFloat(editForm.monthSmallOrder.rateMax, 'unsigned');switchObjMaxAndMin(editForm.monthSmallOrder,'rateMin','rateMax')"
                                    v-model="editForm.monthSmallOrder.rateMax"
                                    placeholder="请输入最大比例"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="近7日累计订单笔数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/003.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/003.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        近7日累计订单笔数=固定基数+云仓订单+章建军平台数据
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数（整数）"
                        prop="weekOrderNumber.radix"
                        :rules="[
                            { required: true, message: '请输入整数', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.weekOrderNumber.radix = switchToInt(editForm.weekOrderNumber.radix)"
                            class="w"
                            v-model="editForm.weekOrderNumber.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="近7日小加工单笔数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/004.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/004.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        近7日小加工单笔数 = 近7日累计订单笔数 * 近7日小加工单比例<br>
                        近7日小加工单比例 = 最小比例和最大比例之间的随机值
                    </p>
                    <el-form-item class="c-form-item-inner" label="近7日小加工单比例范围（小数，例如0.9，代表90%）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="weeksmallOrder.rateMin"
                                :rules="[
                                    { required: true, message: '请输入最小比例', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.weeksmallOrder.rateMin = switchToFloat(editForm.weeksmallOrder.rateMin, 'unsigned');switchObjMaxAndMin(editForm.weeksmallOrder,'rateMin','rateMax')"
                                    v-model="editForm.weeksmallOrder.rateMin"
                                    placeholder="请输入最小比例"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="weeksmallOrder.rateMax"
                                :rules="[
                                    { required: true, message: '请输入最大比例', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.weeksmallOrder.rateMax = switchToFloat(editForm.weeksmallOrder.rateMax, 'unsigned');switchObjMaxAndMin(editForm.weeksmallOrder,'rateMin','rateMax')"
                                    v-model="editForm.weeksmallOrder.rateMax"
                                    placeholder="请输入最大比例"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="各类订单金额占比">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/005.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/005.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       各类订单金额 = 最小值和最大值之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.orderTypeAmount" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'orderTypeAmount.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入订单类别', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">订单类别</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'orderTypeAmount.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min = switchToFloat(item.min, 'unsigned');switchMaxAndMin(editForm.orderTypeAmount, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'orderTypeAmount.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max = switchToFloat(item.max, 'unsigned');switchMaxAndMin(editForm.orderTypeAmount, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.orderTypeAmount.length === 1}" 
                                    :title="editForm.orderTypeAmount.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('orderTypeAmount', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('orderTypeAmount', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="单月线上销售额">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/006.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/006.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       单月线上销售额 = 最小值和最大值之间的数值，该数值有规律递增
                    </p>
                    <el-form-item class="c-form-item-inner" label="单月线上销售额范围（万）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthOnlineSales.min"
                                :rules="[
                                    { required: true, message: '请输入整数最小值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthOnlineSales.min = switchToInt(editForm.monthOnlineSales.min, 'unsigned');switchObjMaxAndMin(editForm.monthOnlineSales)"
                                    v-model="editForm.monthOnlineSales.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthOnlineSales.max"
                                :rules="[
                                    { required: true, message: '请输入整数最大值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthOnlineSales.max = switchToInt(editForm.monthOnlineSales.max, 'unsigned');switchObjMaxAndMin(editForm.monthOnlineSales)"
                                    v-model="editForm.monthOnlineSales.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="单月线下销售额">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/007.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/007.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       单月线下销售额 = 最小值和最大值之间的数值，该数值有规律递增
                    </p>
                    <el-form-item class="c-form-item-inner" label="单月线下销售额范围（万）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthOfflineSales.min"
                                :rules="[
                                    { required: true, message: '请输入整数最小值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthOfflineSales.min = switchToInt(editForm.monthOfflineSales.min, 'unsigned');switchObjMaxAndMin(editForm.monthOfflineSales)"
                                    v-model="editForm.monthOfflineSales.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthOfflineSales.max"
                                :rules="[
                                    { required: true, message: '请输入整数最小值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthOfflineSales.max = switchToInt(editForm.monthOfflineSales.max, 'unsigned');switchObjMaxAndMin(editForm.monthOfflineSales)"
                                    v-model="editForm.monthOfflineSales.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="入驻总部园区">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/008.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/008.png">
                        </div>
                    </el-popover>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="品牌公司"
                                prop="merchantEnterStat.brand"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.merchantEnterStat.brand = switchToInt(editForm.merchantEnterStat.brand, 'unsigned')"
                                    v-model="editForm.merchantEnterStat.brand"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="设计师"
                                prop="merchantEnterStat.designer"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.merchantEnterStat.designer = switchToInt(editForm.merchantEnterStat.designer, 'unsigned')"
                                    v-model="editForm.merchantEnterStat.designer"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="面辅料商"
                                prop="merchantEnterStat.fabric"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.merchantEnterStat.fabric = switchToInt(editForm.merchantEnterStat.fabric, 'unsigned')"
                                    v-model="editForm.merchantEnterStat.fabric"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="工厂"
                                prop="merchantEnterStat.factory"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.merchantEnterStat.factory = switchToInt(editForm.merchantEnterStat.factory, 'unsigned')"
                                    v-model="editForm.merchantEnterStat.factory"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="电商"
                                prop="merchantEnterStat.eBusiness"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.merchantEnterStat.eBusiness = switchToInt(editForm.merchantEnterStat.eBusiness, 'unsigned')"
                                    v-model="editForm.merchantEnterStat.eBusiness"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="服务商"
                                prop="merchantEnterStat.serviceProvider"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.merchantEnterStat.serviceProvider = switchToInt(editForm.merchantEnterStat.serviceProvider, 'unsigned')"
                                    v-model="editForm.merchantEnterStat.serviceProvider"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item class="c-form-item" label="工厂产能排名">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/009.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/009.png">
                        </div>
                    </el-popover>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.plantCapacityRank" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="9">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'plantCapacityRank.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入工厂名称', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">工厂名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'plantCapacityRank.' + index + '.radix'"
                                    :rules="[
                                        { required: true, message: '请输入产能(整数)', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入产能（机*小时）" v-model="item.radix" :disabled="uneditable"
                                        @blur="item.radix=switchToInt(item.radix, 'unsigned');"
                                    >
                                        <template slot="prepend">产能</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.plantCapacityRank.length === 1}" 
                                    :title="editForm.plantCapacityRank.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('plantCapacityRank', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('plantCapacityRank', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="当月期货成衣订单排名">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/010.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/010.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        根据现有的入驻杰丰园区的企业名称进行修改，订单数据=最大值和最小值之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.MonthClothesRank" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'MonthClothesRank.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入企业名称', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">企业名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'MonthClothesRank.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.MonthClothesRank, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'MonthClothesRank.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.MonthClothesRank, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.MonthClothesRank.length === 1}" 
                                    :title="editForm.MonthClothesRank.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('MonthClothesRank', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('MonthClothesRank', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="增速最快">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/011.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/011.png">
                        </div>
                    </el-popover>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="增速最快企业名称"
                                prop="fastestGrowingCompany.name"
                                :rules="[
                                    { required: true, message: '请输入增速最快企业名称', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    v-model="editForm.fastestGrowingCompany.name"
                                    placeholder="请输入名称"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="增速（%）"
                                prop="fastestGrowingCompany.rate"
                                :rules="[
                                    { required: true, message: '请输入增速', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.fastestGrowingCompany.rate=switchToFloat(editForm.fastestGrowingCompany.rate, 'unsigned')"
                                    v-model="editForm.fastestGrowingCompany.rate"
                                    placeholder="请输入增速"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item class="c-form-item" label="服装库存统计">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/012.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/012.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        根据季节分类统计，统计值为最小值和最大值之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.clothesStockStat" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'clothesStockStat.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入季节名称', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">季节名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'clothesStockStat.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.clothesStockStat, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'clothesStockStat.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.clothesStockStat, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.clothesStockStat.length === 1}" 
                                    :title="editForm.clothesStockStat.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('clothesStockStat', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('clothesStockStat', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="平均打版时间">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/013.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/013.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        平均打版时间 = 最小时间和最大时间之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="时间范围（小时）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="averagePlateMakingTime.min"
                                :rules="[
                                    { required: true, message: '请输入最小时间', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.averagePlateMakingTime.min=switchToFloat(editForm.averagePlateMakingTime.min, 'unsigned');switchObjMaxAndMin(editForm.averagePlateMakingTime)"
                                    v-model="editForm.averagePlateMakingTime.min"
                                    placeholder="请输入最小时间"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="averagePlateMakingTime.max"
                                :rules="[
                                    { required: true, message: '请输入最大时间', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.averagePlateMakingTime.max=switchToFloat(editForm.averagePlateMakingTime.max, 'unsigned');switchObjMaxAndMin(editForm.averagePlateMakingTime)"
                                    v-model="editForm.averagePlateMakingTime.max"
                                    placeholder="请输入最大时间"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="小单平均生产周期">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/014.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/014.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        小单平均生产周期 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="周期范围（天）">
                        <el-col :span="6">
                            <el-form-item
                                prop="smallOrderAveragePeriod.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.smallOrderAveragePeriod.min=switchToFloat(editForm.smallOrderAveragePeriod.min, 'unsigned');switchObjMaxAndMin(editForm.smallOrderAveragePeriod)"
                                    v-model="editForm.smallOrderAveragePeriod.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="smallOrderAveragePeriod.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.smallOrderAveragePeriod.max=switchToFloat(editForm.smallOrderAveragePeriod.max, 'unsigned');switchObjMaxAndMin(editForm.smallOrderAveragePeriod)"
                                    v-model="editForm.smallOrderAveragePeriod.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="设计师品牌订单金额">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/015.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/015.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        设计师名称可输入，销售额(元)为最小值和最大值之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.designerOrderAmount" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerOrderAmount.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入设计师名', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">设计师</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerOrderAmount.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.designerOrderAmount, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerOrderAmount.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.designerOrderAmount, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.designerOrderAmount.length === 1}" 
                                    :title="editForm.designerOrderAmount.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('designerOrderAmount', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('designerOrderAmount', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="总部实时订单进度">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/016.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/016.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        订单数据根据衣加加的真实订单数据生成，轮番滚动
                    </p>
                    <el-form-item class="c-form-item-inner" label="输出行数"
                        prop="hqrtOrderProgress.lineNumber"
                        :rules="[
                            { required: true, message: '请输入输出行数', trigger: 'blur'}
                        ]"
                    >
                        <el-input
                            @blur="editForm.hqrtOrderProgress.lineNumber = switchToInt(editForm.hqrtOrderProgress.lineNumber, 'unsigned')"
                            class="w"
                            v-model="editForm.hqrtOrderProgress.lineNumber"
                            placeholder="请输入输出行数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="园区企业年度产值">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/017.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/017.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        销售产值=在全年销售最小值与全年销售最大值之间按自然日递增<br>
                        生产产值=在全年生产最小值与全年生产最大值之间按自然日递增
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.parksCompanyAnnualValue" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="12">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'parksCompanyAnnualValue.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入企业名称', trigger: 'blur'}
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">企业名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                &nbsp;
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.parksCompanyAnnualValue.length === 1}" 
                                    :title="editForm.parksCompanyAnnualValue.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('parksCompanyAnnualValue', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('parksCompanyAnnualValue', index)"
                                ></i>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-top: 16px;">
                            <el-col :span="1">
                                &nbsp;
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'parksCompanyAnnualValue.' + index + '.salesMin'"
                                    :rules="[
                                        { required: true, message: '请输入销售最小值', trigger: 'blur'}
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.salesMin" :disabled="uneditable"
                                        @blur="item.salesMin=switchToInt(item.salesMin, 'unsigned');switchMaxAndMin(editForm.parksCompanyAnnualValue, index,'salesMin', 'salesMax')"
                                    >
                                        <template slot="prepend">销售最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'parksCompanyAnnualValue.' + index + '.salesMax'"
                                    :rules="[
                                        { required: true, message: '请输入销售最大值', trigger: 'blur'}
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.salesMax" :disabled="uneditable"
                                        @blur="item.salesMax=switchToInt(item.salesMax, 'unsigned');switchMaxAndMin(editForm.parksCompanyAnnualValue, index,'salesMin', 'salesMax')"
                                    >
                                        <template slot="prepend">销售最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-top: 16px;">
                            <el-col :span="1">
                                &nbsp;
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'parksCompanyAnnualValue.' + index + '.productionMin'"
                                    :rules="[
                                        { required: true, message: '请输入生产最小值', trigger: 'blur'}
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.productionMin" :disabled="uneditable"
                                        @blur="item.productionMin=switchToInt(item.productionMin, 'unsigned');switchMaxAndMin(editForm.parksCompanyAnnualValue, index,'productionMin', 'productionMax')"
                                    >
                                        <template slot="prepend">生产最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'parksCompanyAnnualValue.' + index + '.productionMax'"
                                    :rules="[
                                        { required: true, message: '请输入生产最大值', trigger: 'blur'}
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.productionMax" :disabled="uneditable"
                                        @blur="item.productionMax=switchToInt(item.productionMax, 'unsigned');switchMaxAndMin(editForm.parksCompanyAnnualValue, index,'productionMin', 'productionMax')"
                                    >
                                        <template slot="prepend">生产最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>
                
            </el-form>
            <div class="bottom-btns-wrap" v-if="!uneditable">
                <el-button class="btn-cancel" @click="cancelEdit">取消</el-button>
                <el-button class="btn-large" type="primary" @click="submitHandle">提交</el-button>
            </div>
        </div>
        
        
    </div>
</template>

<script>
import {ajaxDatav} from '../../common/request_datav.js'
export default {
    data() {
        return {
            uneditable: true,
            editForm: {
                // 当月实时订单总额
                monthOrderAmount: {
                    min: '',  // 最小值
                    max: ''   // 最大值
                },

                // 小加工单订单金额，小加工单订单比例
                monthSmallOrder: {
                    rateMin: '', // 比例最小值
                    rateMax: '', // 比例最大值
                },

                // 近7日累计订单
                weekOrderNumber: {
                    radix: '', // 附加数据
                },

                // 近7日小加工单笔数，近7日小加工单比例
                weeksmallOrder: {
                    rateMin: '', // 比例最小值
                    rateMax: '', // 比例最大值
                },
 
                // 各类订单金额占比
                orderTypeAmount: [
                    {
                        key: 1,
                        name: '', // 订单类别名称
                        min: '',  // 配置最小值
                        max: '',  // 配置最大值
                    }
                ],

                // 单月线上销售额
                monthOnlineSales: {
                    min: '', // 最小值
                    max: ''  // 最大值
                },

                // 单月线下销售额
                monthOfflineSales: {
                    min: '', // 最小值
                    max: ''  // 最大值
                },

                // 入驻总部园区
                merchantEnterStat: {
                    brand: '',          // 品牌公司
                    designer: '',       // 设计师
                    fabric: '',         // 面辅料商
                    factory: '',        // 工厂
                    eBusiness: '',      // 电商
                    serviceProvider: '', // 服务商
                },

                // 工厂产能排名
                plantCapacityRank: [
                    {
                        key: 1,
                        name: '', // 工厂名称
                        radix: '', // 产能数据
                    }
                ],

                // 当月期货成衣订单排名
                MonthClothesRank: [
                    {
                        key: 1,
                        name: '', // 企业名称
                        min: '',  // 配置最小值
                        max: '',  // 配置最大值
                    }
                ],

                // 增速最快
                fastestGrowingCompany: {
                    name: '', // 公司名称
                    rate: '', // 增速
                },

                // 服装库存统计
                clothesStockStat: [
                    {
                        key: 1,
                        name: '', // 季节名称
                        min: '',  // 配置最小值
                        max: ''   // 配置最大值
                    }
                ],

                // 平均打版时间
                averagePlateMakingTime: {
                    min: '',  // 阈值最小值
                    max: '',  // 阈值最大值 
                },

                // 小单平均生产周期
                smallOrderAveragePeriod: {
                    min: '',  // 阈值最小值
                    max: '',  // 阈值最大值 
                },

                // 设计师品牌订单金额
                designerOrderAmount: [
                    {
                        key: 1,
                        name: '', // 设计师名称
                        min: '',  // 配置最小值
                        max: ''   // 配置最大值
                    }
                ],

                // 总部实时订单进度
                hqrtOrderProgress: {
                    lineNumber: '' // 输出行数
                },

                // 园区企业年度产值
                parksCompanyAnnualValue: [
                    {
                        key: 1,
                        name: '', //企业名
                        salesMin: '', // 销售最小值
                        salesMax: '', // 销售最大值
                        productionMin: '', // 生产最小值
                        productionMax: '', // 生产最大值

                    }
                ]
       
            }
        }
    },
    created() {
        this.getData();
    },
    methods: {
        // 编辑操作
        editHandle() {
            this.uneditable = false
        },
        // 取消编辑
        cancelEdit() {
            this.$confirm('确认取消编辑吗?', '提示', {
                confirmButtonText: '取消编辑',
                cancelButtonText: '继续编辑',
                type: 'warning'
            }).then(() => {
                this.uneditable = true
                this.$refs['editForm'].clearValidate()
                this.getData();
            })
        },
        // 跳转外部链接
        linkToDataV() {
            window.open('https://datav.aliyuncs.com/share/07ba8b499a33142bca65b110d799d6cf')
        },
        // 立即生效
        takeEffectAtOnce() {
            this.$confirm('数据配置默认第二天零点生效，若需立即生效，可使用本功能。本功能将立即刷新数据到大屏，有可能造成当日数据前后不一致。请谨慎使用。', '提示', {
                confirmButtonText: '立即生效',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log('立即生效')
                ajaxDatav.post('/data-statistics/refreshByNumber', {
                    number: 2
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success('提交成功，配置的数据会立即生效到大屏！');
                    } else {
                        this.$message.error(res.msg)
                    }
                }).catch(e => {
                    console.error(e)
                })
            }).catch(err=> {
                console.log(err)
            })
        },
        // 回到顶部
        toPageTop() {
            document.querySelector('#mainBox').scrollTop = 0;
        },
        // 删除一行
        removeLine(key, index) {
            let length = this.editForm[key].length
            if (length <= 1) return
            this.editForm[key].splice(index, 1)
        },
        // 添加一行
        addLine(key, index) {
            let d = Date.now()
            let item
            if (key == 'plantCapacityRank') {
                item = {
                    key: d,
                    name: '',
                    radix: ''
                }
            }
            if (key == 'orderTypeAmount' || key == 'MonthClothesRank' || key == 'clothesStockStat' 
                || key == 'designerOrderAmount'
            ) {
                item = {
                    key: d,
                    name: '',
                    min: '',
                    max: ''
                }
            }
            if (key == 'parksCompanyAnnualValue') {
                item = {
                    key: d,
                    name: '', 
                    salesMin: '', 
                    salesMax: '', 
                    productionMin: '', 
                    productionMax: '',
                }
            }
            this.editForm[key].splice(index+1, 0, item)
        },
        // 转化为整数
        switchToInt(value, type) {
            let v = parseInt(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 转化为浮点数
        switchToFloat(value, type) {
            let v = parseFloat(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 获取数据
        getData() {
            ajaxDatav.get('/data-setting/getByNumber', {
                number: 2
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    if (res.data && res.data.content) {
                        try {
                            let content = JSON.parse(res.data.content);
                            this.editForm = {
                                ...this.editForm,
                                ...content
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(e => {
                console.error(e);
            })
        },
        // 提交表单
        submitHandle() {
            console.log('submit');
            // console.log(this.editForm);
            // console.log(JSON.stringify(this.editForm));
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: '正在提交数据...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    ajaxDatav.post('/data-setting/save', {
                        content: JSON.stringify(this.editForm),
                        number: 2
                    }).then(res => {
                        if (res.code == 200) {
                            this.$message.success('提交成功');
                            this.uneditable = true
                            this.getData();
                        } else {
                            this.$message.error(res.msg)
                        }
                    }).catch(e => {
                        console.error(e)
                    }).finally(() => {
                        loading.close();
                    })
                } else {
                    this.$message.error('校验不通过，请检查表单')
                }
            })
        },
        // 自动切换对象中最大值和最小值
        switchObjMaxAndMin(obj, min='min', max='max') {
            if (obj[min] === '' || obj[max] === '') return
            if (obj[min] > obj[max]) {
                let middle = obj[min]
                obj[min] = obj[max]
                obj[max] = middle
            }
        },
        // 自动切换列表中最大值和最小值
        switchMaxAndMin(list, index, min='min', max='max') {
            if (list[index][min] === '' || list[index][max] === '') return
            if (list[index][min] > list[index][max]) {
                let middle = list[index][min]
                list[index][min] = list[index][max]
                list[index][max] = middle
            }
        }
    }
}
</script>

<style scoped lang="scss">
.page-wrapper {
    background: #fff;
    padding-bottom: 80px;
    min-height: 100px;
    .tit {
        margin: 0;
        padding: 24px;
        font-size: 20px;
        color: #111;
        font-weight: normal;
    }
    .top-btns {
        position: fixed;
        top: 40%;
        right: 32px;
        z-index: 100;
        .r-btn {
            margin-top: 6px;
        }
    } 
    .datav-form-wrapper {
        width: 900px;
        padding: 0 24px;
        .w {
            width: 400px;
        }
        .w2 {
            width: 200px;
        }
        .info {
            font-size: 13px;
            color: #888;
            line-height: 1.5;
        }
    }
    .c-row-wrap {
        padding: 8px 0;
    }
    .c-sort-num {
        margin-top: 12px;
        display: block;
        width: 20px;
        height: 20px;
        border: 1px solid #999;
        line-height: 20px;
        text-align: center;
        color: #999;
        font-size: 12px;
        border-radius: 50%;
    }
    .c-remove {
        margin-right: 4px;
        cursor: pointer;
        font-size: 16px;
        &.disabled {
            color: #ccc;
            cursor: no-drop;
        }
    }
    .c-add {
        font-size: 16px;
        cursor: pointer;
    }
    .bottom-btns-wrap {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0 20px 0px;
        text-align: center;
        z-index: 1;
        background: #fff;
        box-shadow: 0 -2px 10px #ccc;
        .btn-large {
            padding: 14px 120px;
        }
        .btn-cancel {
            padding-top: 14px;
            padding-bottom: 14px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/datav/park-headquarters.vue